/*
 * Copyright (c) 2021. American Express Company
 */

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
// @ts-ignore
TimeAgo.addDefaultLocale(en);

export default class TimeAgoService {
    public static parse(date: Date): string {
        const timeAgo: TimeAgo = new TimeAgo('en-US');
        try {
            return timeAgo.format(date).toString();
        } catch (e) {
            console.error('Could not parse date into human-readable string.');
            return null;
        }
    }
}
